/* eslint formatjs/no-literal-string-in-jsx: "error" */
import { Button } from "@carrotfertility/carotene"
import React, { useEffect } from "react"
import { FormattedMessage } from "react-intl"
import { useSelector } from "react-redux"
import { getEmployeeId } from "reducers/userInfo"
import { getHeap } from "utils/heap"

export const FindASessionButton = ({
  sessionPickerUrl,
  groupSlugId
}: {
  sessionPickerUrl: string
  groupSlugId: string
}): JSX.Element => {
  const employeeId = useSelector(getEmployeeId)
  const openCalendly = (): void => {
    // Adapted from the "Pop-up text" JavaScript snippet Calendly generates for us
    // https://help.calendly.com/hc/en-us/articles/223147027-Embed-options-overview#1
    window.Calendly.initPopupWidget({
      url: sessionPickerUrl,
      utm: {
        utmCampaign: employeeId,
        utmSource: groupSlugId
      }
    })
  }

  useEffect(() => {
    const trackScheduledEvent = (e: MessageEvent): void => {
      const isCalendlyEvent = (e: MessageEvent): boolean => {
        return e.origin === "https://calendly.com" && e.data.event && e.data.event.indexOf("calendly.") === 0
      }
      const isScheduledEvent = (e: MessageEvent): boolean => {
        return e.data.event === "calendly.event_scheduled"
      }
      if (isCalendlyEvent(e) && isScheduledEvent(e)) {
        getHeap().track("Group chat scheduled", {
          "Group Slug ID": groupSlugId
        })
      }
    }

    window.addEventListener("message", trackScheduledEvent)

    return () => {
      window.removeEventListener("message", trackScheduledEvent)
    }
  }, [groupSlugId])

  return (
    <Button id="find-group-session-button" variant="primary" onClick={openCalendly}>
      <FormattedMessage defaultMessage="Find a session" />
    </Button>
  )
}
